import script from "./gameView.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameView.vue?vue&type=script&setup=true&lang=ts"

import "./gameView.vue?vue&type=style&index=0&id=06462425&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06462425"]])

export default __exports__